export default __webpack_public_path__ + "static/media/imagem_01.06a9f040.png";